module.exports = __webpack_public_path__ + "media/images/nyc-dd4760d6f4266c26dd043dc7ec86db03.jpg";